(function() {
    'use strict';

    angular
        .module('bhsApp')
        .controller('ElementDetailController', ElementDetailController);

    ElementDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Element', 'DataElement'];

    function ElementDetailController($scope, $rootScope, $stateParams, previousState, entity, Element, DataElement) {
        var vm = this;

        vm.element = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bhsApp:elementUpdate', function(event, result) {
            vm.element = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
